import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';
import { useContext } from 'react';

const useDeletePendingUpdate = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (documentToDelete) => {
      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/charterer/profile/delete/pendingUpdates`,
        {
          data: documentToDelete,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('pendingDeletes');
      },
    }
  );
};

export default useDeletePendingUpdate;
